import React from "react";
import { connect } from "react-redux";

// Assets
import PhoneImage from "../../assets/images/landing/phone.png";
import App1 from "../../assets/images/landing/app-01.png";
import App2 from "../../assets/images/landing/app-02.png";
import App3 from "../../assets/images/landing/app-03.png";
import App4 from "../../assets/images/landing/app-04.png";
import App5 from "../../assets/images/landing/app-05.png";
import App6 from "../../assets/images/landing/app-06.png";

import MobileBG5 from "../../assets/images/landing/image-06.png";
// Styles
import "../../styles/components/landing/phone.scss";

const PhoneDisplay = (props) => {
    return (
        <div className="phone-container">
            <div className="phone">
                <img src={PhoneImage} alt="Phone outline" />
            </div>
            <div className="content">
                <ul>
                    <li className={props.phoneSlide === 1 ? "active" : ""}>
                        <img src={App1} alt="App screen 1" />
                    </li>
                    <li className={props.phoneSlide === 2 ? "active" : ""}>
                        <img src={App2} alt="App screen 2" />
                    </li>
                    <li className={props.phoneSlide === 3 ? "active" : ""}>
                        <img src={App3} alt="App screen 3" />
                    </li>
                    <li className={props.phoneSlide === 4 ? 'active' : ''}>
                        <img
                            src={props.isMobileSite ? MobileBG5 : App5}
                            alt="App screen 5"
                        />
                    </li>
                    <li className={props.phoneSlide === 5 ? 'active' : ''}>
                        <img
                            src={props.isMobileSite ? MobileBG5 : App5}
                            alt="App screen 5"
                        />
                    </li>
                    <li className={props.phoneSlide === 6 ? "active" : ""}>
                        <img src={App6} alt="App screen 6" />
                    </li>
                </ul>
            </div>
            <div
                className={
                    props.phoneSlide === 1
                        ? "bouncy-arrow active"
                        : "bouncy-arrow"
                }
            >
                <svg
                    width="46"
                    height="23"
                    xmlns="http://www.w3.org/2000/svg"
                    overflow="hidden"
                >
                    <defs>
                        <clipPath id="clip0">
                            <rect x="0" y="0" width="46" height="23" />
                        </clipPath>
                        <image
                            width="54"
                            height="53"
                            href="data:image/png;base64,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"
                            preserveAspectRatio="none"
                            id="img1"
                        ></image>
                        <pattern
                            width="54"
                            height="53"
                            patternUnits="userSpaceOnUse"
                            id="pattern2"
                            overflow="hidden"
                            patternTransform="scale(0.978263 0.996721)"
                        >
                            <use
                                width="100%"
                                height="100%"
                                href="#img1"
                            ></use>
                        </pattern>
                    </defs>
                    <g clip-path="url(#clip0)">
                        <path
                            d="M0 0 52.8262 0 52.8262 52.8262 0 52.8262Z"
                            fill="url(#pattern2)"
                            transform="matrix(1.01536 0 0 1 -3.85653 -8.73323)"
                        />
                    </g>
                </svg>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        isMobileSite: state.utility.isMobileSite,
    };
};

export default connect(mapStateToProps, {})(PhoneDisplay);
